// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': '日本語',
  'smarthr-ui/ActionDialog/closeButtonLabel': 'キャンセル',
  'smarthr-ui/AppHeader/school': 'スクール',
  'smarthr-ui/AppHeader/help': 'ヘルプ',
  'smarthr-ui/AppHeader/userSettings': '個人設定',
  'smarthr-ui/AppHeader/releaseNotes': 'リリースノート',
  'smarthr-ui/AppHeader/releaseNotesLoadError': 'リリースノートの読み込みに失敗しました。\n時間をおいて、やり直してください。',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': 'すべてのリリースノートを見る',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': 'アプリ',
  'smarthr-ui/AppHeader/MobileHeader/account': 'アカウント',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': 'メニューを開く',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': 'メニューを閉じる',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': 'すべてのアプリ',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': '管理メニュー',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': '最新のリリースノート',
  'smarthr-ui/AppHeader/MobileHeader/back': '戻る',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': '開く',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': '閉じる',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': 'アプリ名を入力してください。',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': 'よく使うアプリ',
  'smarthr-ui/AppHeader/Launcher/allModeText': 'すべてのアプリ',
  'smarthr-ui/AppHeader/Launcher/listText': 'アプリ一覧',
  'smarthr-ui/AppHeader/Launcher/helpText': 'よく使うアプリとは',
  'smarthr-ui/AppHeader/Launcher/searchResultText': '検索結果',
  'smarthr-ui/AppHeader/Launcher/emptyText': '該当するアプリが見つかりませんでした。',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': '表示順',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': '選択中',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': 'デフォルト',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': 'アプリ名の昇順',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': 'アプリ名の降順',
  'smarthr-ui/AppLauncher/showAllText': 'すべて見る',
  'smarthr-ui/AppLauncher/triggerLabel': 'アプリ',
  'smarthr-ui/Browser/notFoundDescription': '別の条件を試してください。',
  'smarthr-ui/Browser/notFoundTitle': '該当する項目がありません。',
  'smarthr-ui/Button/loading': '処理中',
  'smarthr-ui/Calendar/currentYear': '現在の年',
  'smarthr-ui/Calendar/nextMonth': '次の月へ',
  'smarthr-ui/Calendar/previousMonth': '前の月へ',
  'smarthr-ui/Calendar/selectYear': '年を選択する',
  'smarthr-ui/Combobox/addItemButtonLabel': '「{name}」を追加',
  'smarthr-ui/Combobox/loadingText': '処理中',
  'smarthr-ui/Combobox/noResultsText': '一致する選択肢がありません。',
  'smarthr-ui/DropdownMenuButton/triggerActive': '候補を閉じる',
  'smarthr-ui/DropdownMenuButton/triggerInactive': '候補を開く',
  'smarthr-ui/DropZone/selectButtonLabel': 'ファイルを選択',
  'smarthr-ui/FileViewer/rotateAlt': '左回転',
  'smarthr-ui/FileViewer/scaleDownAlt': '縮小',
  'smarthr-ui/FileViewer/scaleRateLabel': '拡大率',
  'smarthr-ui/FileViewer/scaleUpAlt': '拡大',
  'smarthr-ui/FileViewer/unsupportedFileText': 'サポートされていない形式のファイルです。',
  'smarthr-ui/FilterDropdown/applyText': '適用',
  'smarthr-ui/FilterDropdown/cancelText': 'キャンセル',
  'smarthr-ui/FilterDropdown/resetText': '絞り込み条件を解除',
  'smarthr-ui/FilterDropdown/status': '適用中',
  'smarthr-ui/FilterDropdown/triggerText': '絞り込み',
  'smarthr-ui/FormDialog/closeButtonLabel': 'キャンセル',
  'smarthr-ui/InformationPanel/closeButtonLabel': '閉じる',
  'smarthr-ui/InformationPanel/openButtonLabel': '開く',
  'smarthr-ui/InputFile/destroy': '削除',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': '選択中',
  'smarthr-ui/Loader/alt': '処理中',
  'smarthr-ui/MessageDialog/closeButtonLabel': '閉じる',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': '閉じる',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': 'ダイアログの位置',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': 'ドラッグ可能',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': '矢印キーを押して上下左右に移動できます',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '上から{top}px、左から{left}px',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': 'を削除',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': '選択済みアイテム',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': '閉じる',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': '最初へ',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': '最後へ',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': '次へ',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': '前へ',
  'smarthr-ui/Pagination/itemButtonLabel': '{page}ページ目',
  'smarthr-ui/Pagination/navigationLabel': 'ページネーション',
  'smarthr-ui/RequiredLabel/text': '必須',
  'smarthr-ui/SearchInput/iconAlt': '検索',
  'smarthr-ui/SideMenu/navigationLabel': 'サイドメニュー',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': 'クリア',
  'smarthr-ui/SortDropdown/applyText': '適用',
  'smarthr-ui/SortDropdown/ascLabel': '昇順',
  'smarthr-ui/SortDropdown/cancelText': 'キャンセル',
  'smarthr-ui/SortDropdown/descLabel': '降順',
  'smarthr-ui/SortDropdown/sortFieldLabel': '並べ替え項目',
  'smarthr-ui/SortDropdown/sortOrderLegend': '並び順',
  'smarthr-ui/StepFormDialog/backButtonLabel': '戻る',
  'smarthr-ui/StepFormDialog/closeButtonLabel': 'キャンセル',
  'smarthr-ui/StepFormDialog/nextButtonLabel': '次へ',
  'smarthr-ui/StepStatusIcon/closedAlt': '中断',
  'smarthr-ui/StepStatusIcon/completedAlt': '完了',
  'smarthr-ui/Textarea/availableLetters': 'あと{availableLetters}文字',
  'smarthr-ui/Textarea/maxLettersExceeded': '{exceededLetters}文字オーバー',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': '最大{maxLetters}文字入力できます',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': '別タブで開く',
  'smarthr-ui/Th/sortDirectionAsc': '昇順',
  'smarthr-ui/Th/sortDirectionDesc': '降順',
  'smarthr-ui/Th/sortDirectionNone': '並び替えなし',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': 'すべての項目を選択/解除',
  'smarthr-ui/ThCheckbox/checkColumnName': '選択',
} as const
